import createIcon from '../../createIcon';

/**
 * @component @name NavigateBefore
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNzA0OSA3LjQxTDE0LjI5NDkgNkw4LjI5NDkyIDEyTDE0LjI5NDkgMThMMTUuNzA0OSAxNi41OUwxMS4xMjQ5IDEyTDE1LjcwNDkgNy40MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NavigateBefore = createIcon('NavigateBefore', [
  [
    'path',
    {
      d: 'M15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59L11.1249 12L15.7049 7.41Z',
      key: '2nwmtn',
    },
  ],
]);

export default NavigateBefore;
